import * as React from "react";
import { useContext } from "react";
import styles from '../../styles/pokemon.module.scss';
import { Image, Popup, mergeStyleSets } from "@fluentui/react";
import ImageViewerSplashContext from "../../_contexts/ImageViewerContext";

export interface IImageViewerSplashProps {
    // eslint-disable-next-line
}

const popupStyles = mergeStyleSets({
  root: {
    background: 'rgba(0, 0, 0, 0.5)',
    bottom: '0',
    left: '0',
    position: 'fixed',
    right: '0',
    top: '0',
    zIndex:999
  },
  content: {
    backgroundColor: "transparent",
    left: '50%',
    padding: '0 2em 2em',
    position: 'absolute',
    maxWidth: "90%!important",
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const ImageViewerSplash : React.FunctionComponent<IImageViewerSplashProps> = (props : IImageViewerSplashProps) => {   
    const { imgUrl,setImgUrl,windowSize } = useContext(ImageViewerSplashContext);

    return (
        <Popup
            hidden={!imgUrl}
            role="dialog"
            aria-modal="true"
            className={popupStyles.root}
        >
            <div role="document" className={popupStyles.content}>
                <Image  className={styles.popupImage}
                        style={{maxHeight: windowSize.y - ((windowSize.y/100) * 25), height: windowSize.y - ((windowSize.y/100) * 25)}}
                        onError={(e) => { e.currentTarget.onerror = null;
                                            e.currentTarget.src=`${imgUrl}`}}
                        onClick={() => {setImgUrl(undefined)}}
                        src={imgUrl?.replace(".webp",".png")}
                        alt=""/>
            </div>
        </Popup>
    );
}

export default ImageViewerSplash;